export class CompleteOrderLineRequest {
  constructor(
    public itemId: number,
    public deliveredQuantity: number,
    public deliveredLot: string | undefined,
    public deliveredBestBefore: string | undefined,
    public deliveredExpiry: string | undefined
  ) { }
}

export default class CompleteOrderRequest {
  constructor(public lines: CompleteOrderLineRequest[]) {}
}
